import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const usr = localStorage.getItem('usr');
  if (usr) {
    try {
      const { token } = JSON.parse(usr);
      if (token) {
        const cloned = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next(cloned);
      }
    } catch {}
  }
  return next(req);
};
